<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    fill="none"
    aria-hidden="true"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-miterlimit="10"
    stroke-width="1.5"
  >
    <path
      d="M22.612 7.528 7.548 22.59a.423.423 0 0 1-.613 0l-3.853-3.853a.423.423 0 0 1 0-.613L18.145 3.06a.423.423 0 0 1 .614 0l3.853 3.854c.175.131.175.438 0 .613ZM9.562 20.446l-1.226-1.27M11.095 18.87l-.92-.92M12.671 17.337l-1.27-1.227M14.204 15.804l-.92-.963M15.736 14.228l-1.226-1.226M17.313 12.695l-.92-.92M18.846 11.162l-1.226-1.27M20.378 9.586l-.92-.92"
    />
  </svg>
</template>
